export const dateUtil = () => {

  const dateStringToDateObject = (year, month, date) => {
    return new Date(parseInt(year), parseInt(month)-1, parseInt(date))
  }

  // 曜日インデックスを曜日文字列に変換
  const dayToDayString = (day) => {
    switch(day) {
      case 0: return '日';
      case 1: return '月';
      case 2: return '火';
      case 3: return '水';
      case 4: return '木';
      case 5: return '金';
      case 6: return '土';
      default: return '';
    }
  }

  // 日付文字列をDate型に変更し、operator指定の比較演算子で比較した結果を返す
  const comparisonDateString = (dateStr1, operator, dateStr2) => {
    const date1 = new Date(dateStr1);
    const date2 = new Date(dateStr2);
    switch (operator) {
      case '==':
        return date1.getTime() == date2.getTime(); break;
      case '===':
        return date1.getTime() === date2.getTime(); break;
      case '>':
        return date1.getTime() > date2.getTime(); break;
      case '<':
        return date1.getTime() < date2.getTime(); break;
      case '>=':
        return date1.getTime() >= date2.getTime(); break;
      case '<=':
        return date1.getTime() <= date2.getTime(); break;
      default: return false; break;
    }
  }

  // 日付フォーマットチェック
  const checkDateFormat = (dateStr) => {
    const regexpPattern = /^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;
    return regexpPattern.exec(dateStr);
  }

  // 妥当な日付の検討
  const examValidDate = (dateStr) => {
    const convertDateStr = new Date(dateStr).toLocaleDateString('ja-JP', {year: 'numeric', month: '2-digit', day: '2-digit'});
    return dateStr === convertDateStr;
  }

  // フォーマット変換（yyyymmdd → yyyy/mm/dd）
  const formatDateWithSlash = (dateStr) => {
    if (dateStr !== null && dateStr.length === 8) {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${year}/${month}/${day}`;
    }
    return '';
  }

  // フォーマット変換 (yyyy/mm/dd hh:mm)
  const formatDateWithHourMin = (dateStr) => {
  if (!dateStr) return '';

  const year = dateStr.substring(0, 4);
  const month = dateStr.substring(5, 7);
  const day = dateStr.substring(8, 10);
  const hour = dateStr.substring(11, 13);
  const minute = dateStr.substring(14, 16);

  return `${year}/${month}/${day} ${hour}:${minute}`;
  };

    // 伝票番号（5桁ゼロ埋め）
  const formatChitNumber = (chitNumber) => {
    return chitNumber != null
      ? String(chitNumber).padStart(5, '0')
      : '';
  }

  // Date → YYYYMMDD（number）
  const dateToNumber = (date) => {
    return date.getFullYear() * 10000
      + (date.getMonth() + 1) * 100
      + date.getDate();
  }

  // YYYYMMDD → Date
  const numberToDate = (dateNumber) => {
    const str = String(dateNumber);
    if (!/^\d{8}$/.test(str)) return null;

    return new Date(
      Number(str.slice(0, 4)),
      Number(str.slice(4, 6)) - 1,
      Number(str.slice(6, 8))
    );
  }

  // 3ヶ月後の日付（同日 or 月末）
  const getLimitDate = (dateNumber) => {
    const baseDate = numberToDate(dateNumber);
    if (!baseDate) return NaN;

    const limitMonths = 3;

    const year = baseDate.getFullYear();
    const month = baseDate.getMonth();
    const day = baseDate.getDate();

    const base = new Date(year, month + limitMonths, 1);

    const lastDay = new Date(
      base.getFullYear(),
      base.getMonth() + 1,
      0
    ).getDate();

    const finalDay = Math.min(day, lastDay);

    return dateToNumber(
      new Date(base.getFullYear(), base.getMonth(), finalDay)
    );
  }

  // 3ヶ月経過判定
  const isTimeLimitOver = (chitDate) => {
    if (chitDate == null) return false;

    const limitDate = getLimitDate(chitDate);
    const today = dateToNumber(new Date());

    return limitDate <= today;
  }

  return {
    dateStringToDateObject,
    dayToDayString,
    comparisonDateString,
    checkDateFormat,
    examValidDate,
    formatDateWithSlash,
    formatDateWithHourMin,
    formatChitNumber,
    dateToNumber,
    numberToDate,
    getLimitDate,
    isTimeLimitOver
  }

}